/**
 * Helper script to clean up test data from Firestore
 * Run this from the browser console before seeding new data
 */

import { collection, getDocs, deleteDoc, doc, query, where } from 'firebase/firestore';
import { db } from '../services/firebase';
import { COLLECTIONS } from '../constants/collections';

export async function cleanupTestData(landlordId: string) {
  // eslint-disable-next-line no-console
  console.log('🧹 Cleaning up test data for landlordId:', landlordId);

  try {
    let totalDeleted = 0;

    // Delete Payments
    const paymentsQuery = query(
      collection(db, COLLECTIONS.PAYMENTS),
      where('landlordId', '==', landlordId)
    );
    const paymentsSnapshot = await getDocs(paymentsQuery);
    for (const docRef of paymentsSnapshot.docs) {
      await deleteDoc(doc(db, COLLECTIONS.PAYMENTS, docRef.id));
      totalDeleted++;
    }
    // eslint-disable-next-line no-console
    console.log(`✅ Deleted ${paymentsSnapshot.size} payments`);

    // Delete Tenants
    const tenantsQuery = query(
      collection(db, COLLECTIONS.TENANTS),
      where('landlordId', '==', landlordId)
    );
    const tenantsSnapshot = await getDocs(tenantsQuery);
    for (const docRef of tenantsSnapshot.docs) {
      await deleteDoc(doc(db, COLLECTIONS.TENANTS, docRef.id));
      totalDeleted++;
    }
    // eslint-disable-next-line no-console
    console.log(`✅ Deleted ${tenantsSnapshot.size} tenants`);

    // Delete Properties
    const propertiesQuery = query(
      collection(db, COLLECTIONS.PROPERTIES),
      where('landlordId', '==', landlordId)
    );
    const propertiesSnapshot = await getDocs(propertiesQuery);
    for (const docRef of propertiesSnapshot.docs) {
      await deleteDoc(doc(db, COLLECTIONS.PROPERTIES, docRef.id));
      totalDeleted++;
    }
    // eslint-disable-next-line no-console
    console.log(`✅ Deleted ${propertiesSnapshot.size} properties`);

    // eslint-disable-next-line no-console
    console.log(`🎉 Cleanup complete! Deleted ${totalDeleted} total documents`);
    return { success: true, deleted: totalDeleted };
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('❌ Error cleaning up data:', error);
    return { success: false, error };
  }
}

// Export for use in browser console
declare global {
  interface Window {
    cleanupTestData: typeof cleanupTestData;
  }
}

if (import.meta.env?.DEV) {
  window.cleanupTestData = cleanupTestData;
}
